import React from 'react';
import classNames from 'classnames';

export interface FooterContactInfoProps {
  className?: string;
  contactInfo: string;
  id?: string;
  method?: 'phone' | 'mail';
  size: 'slim' | 'medium';
}

const FooterContactInfo = ({ className, method, id, contactInfo, size }: FooterContactInfoProps): JSX.Element => {
  const footerContactInfo = classNames(className, 'usa-footer__contact-info', {
    'grid-row grid-gap': size === 'medium',
  });
  let link = '';
  switch (method) {
    case 'phone':
      link = `tel:${contactInfo}`;
      break;
    case 'mail':
      link = `mailto:${contactInfo}`;
      break;
    default:
      link = contactInfo;
      break;
  }
  if (size === 'slim') {
    return (
      <div className="grid-col-auto mobile-lg:grid-col-12 desktop:grid-col-auto">
        <div className={footerContactInfo}>
          <a id={id} href={link}>
            {contactInfo}
          </a>
        </div>
      </div>
    );
  }
  return (
    <div className="grid-col-auto">
      <a id={id} href={link}>
        {contactInfo}
      </a>
    </div>
  );
};

export default FooterContactInfo;
